"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCsvJobIgnoreErrorDiv = exports.InputCsvJobType = exports.InputCsvColumnType = exports.InputActionProgress = void 0;
exports.InputActionProgress = {
    Waiting: 1,
    SystemError: 9,
    Loading: 11,
    LoadDone: 15,
    LoadError: 19,
    Parsing: 31,
    FileParseDone: 35,
    FileParseError: 39,
    Validating: 51,
    ValidationDone: 55,
    ValidationError: 59,
    Executing: 71,
    ExecutionDone: 75,
    ExecutionError: 79,
};
exports.InputCsvColumnType = {
    String: 0,
    Integer: 1,
    Float: 2,
    Date: 3,
    Datetime: 4,
    Bool: 5,
};
exports.InputCsvJobType = {
    Temporary: 0,
    Storage: 1,
};
exports.InputCsvJobIgnoreErrorDiv = {
    StopOnError: 1,
    ProceedOnError: 2,
};
